/**
 * Verify user screen
 * Verify user email after signup
 * After successful verification the user is logged in automatically and redirected to the create profile screen
 */
import React from "react"
import { ThemeProvider } from "styled-components"
import theme from "styles/theme-main"
import { getEvent, registerEvent, getPublicCountries } from "services/public"
import AppLoader from "components/AppLoader"
import RegisterModal from "./RegisterModal"
import EventInformation from "./components/EventInformation"
import EventConfirmation from "./components/EventConfirmation"
import ErrorModal from "components/ErrorModal"
import ReactGA from "utils/GA"
import { getSubdomainFromUrl } from "utils/productUtils"
import { Helmet } from "react-helmet-async"

export class EventView extends React.Component {
  state = { loadingEvent: true, isRegisterModal: false, loadError: false }

  initEvent = async (props = this.props) => {
    const { organization, match } = props

    try {
      const res = await getEvent(match.params.eventId)

      if (organization.id !== res.data.organization.id) {
        await this.props.getOrganization(getSubdomainFromUrl())
      }
      const countries = await getPublicCountries()
      this.setState({
        loadingEvent: false,
        event: res.data,
        COUNTRY: countries.data,
      })
    } catch (error) {
      this.setState({
        loadError: true,
        loadingEvent: false,
      })
    }
  }

  componentWillUpdate = async nextProps => {
    if (nextProps.organization && !this.props.organization) {
      await this.initEvent(nextProps)
    }
  }

  componentDidMount = async () => {
    this.setState({
      loadingEvent: true,
    })
    // load the user to get the email to display
    if (this.props.organization) {
      await this.initEvent()
    }
  }

  register = () => {
    ReactGA.event({
      category: "Candidate Metrics",
      action: "Event - Registration started",
      label: "Event - Registration started",
      value: 1,
    })
    if (this.state.event.linkedRoleId) {
      this.props.history.push(`/apply/${this.state.event.linkedRoleId}`)
    } else {
      this.setState({
        isRegisterModal: true,
      })
    }
  }

  closeRegister = () => {
    this.setState({
      isRegisterModal: false,
    })
  }

  completeRegister = resource => {
    ReactGA.event({
      category: "Candidate Metrics",
      action: "Event - Registration complete",
      label: "Event - Registration complete",
      value: 1,
    })
    const { match } = this.props
    registerEvent(match.params.eventId, resource)
      .then(() => {
        this.setState({
          isRegisterModal: false,
          isConfirmed: true,
        })
      })
      .catch(err => {
        if (err?.response?.data?.message === "Event Full") {
          this.setState({
            isEventFullErrorModalOpen: true,
          })
        } else {
          this.setState({
            isErrorModalOpen: true,
          })
        }
      })
  }

  closeErrorModal = () => {
    this.setState({
      isErrorModalOpen: false,
    })
  }

  render() {
    const { loadingEvent, event, COUNTRY } = this.state
    const configuration =
      !loadingEvent && event.configuration && JSON.parse(event.configuration)
    const { organization } = this.props
    return (
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>
            {event ? `${event.name} |` : ""}{" "}
            {organization ? `${organization.name} |` : ""} Event registration
          </title>
          <meta
            name="title"
            content={`${event && event.name} | ${organization &&
              organization.name} | Event registration`}
          />
          <meta name="description" content={event && event.description} />
        </Helmet>
        {loadingEvent || !organization ? (
          <AppLoader />
        ) : (
          <React.Fragment>
            {this.state.isConfirmed
              ? event && (
                  <EventConfirmation
                    organization={organization}
                    event={event}
                  />
                )
              : event && (
                  <EventInformation
                    event={event}
                    organization={organization}
                    register={this.register}
                  />
                )}

            <RegisterModal
              configuration={configuration}
              isModalOpen={this.state.isRegisterModal}
              onConfirm={this.completeRegister}
              onClose={this.closeRegister}
              organization={this.props.organization}
              COUNTRY={COUNTRY}
            />
            <ErrorModal
              title="Already registered"
              message={"This email is already registered for this event"}
              onClose={this.closeErrorModal}
              isModalOpen={this.state.isErrorModalOpen}
            />
            <ErrorModal
              title="EVENT NO LONGER AVAILABLE"
              message={
                "This event has now passed, or is no longer open for registration."
              }
              isModalOpen={this.state.loadError}
            />
            <ErrorModal
              title="EVENT FULL"
              message={
                "This event is full and is no longer open for registration."
              }
              isModalOpen={this.state.isEventFullErrorModalOpen}
            />
          </React.Fragment>
        )}
      </ThemeProvider>
    )
  }
}

export default EventView
